document.addEventListener("DOMContentLoaded", () => {
  const siteMenu = document.querySelector(".site-menu");

  // Burger menu logic (only if .site-menu exists)
  if (siteMenu) {
    const siteMenuBurger = siteMenu.querySelector(".site-menu__burger");
    const siteMenuOverlay = siteMenu.querySelector(".site-menu__overlay");
    const siteMenuLogo = document.querySelector(".site-menu__logo");

    // Hero elements used as scroll triggers
    const blockHeroSelectors = [
      ".gb-block-homepage-hero",
      ".gb-block-secondary-hero",
      ".gb-block-tertiary-hero",
    ];

    const blockHeroes = document.querySelectorAll(blockHeroSelectors.join(","));
    const blockFirstHero = blockHeroes.length ? blockHeroes[0] : null;
    const blockLastHero = blockHeroes.length
      ? blockHeroes[blockHeroes.length - 1]
      : null;

    if (siteMenuBurger && siteMenuOverlay) {
      // Burger Logic
      const burgerIconDefault = siteMenuBurger.innerHTML.trim();
      const burgerIconClose = `Close`.trim();

      let isOpen = false;

      function openMenu() {
        if (isOpen) return;
        isOpen = true;
        siteMenu.classList.add("is-open");
        siteMenuOverlay.classList.add("is-open");
        siteMenuBurger.setAttribute("aria-expanded", "true");
        siteMenuBurger.setAttribute("aria-label", "Close menu");
        siteMenuBurger.innerHTML = burgerIconClose;
        document.documentElement.style.overflow = "hidden";
        document.addEventListener("keydown", handleKeydown);
      }

      function closeMenu() {
        if (!isOpen) return;
        isOpen = false;
        siteMenu.classList.remove("is-open");
        siteMenuOverlay.classList.remove("is-open");
        siteMenuBurger.setAttribute("aria-expanded", "false");
        siteMenuBurger.setAttribute("aria-label", "Open menu");
        siteMenuBurger.innerHTML = burgerIconDefault;
        document.documentElement.style.overflow = "";
        document.removeEventListener("keydown", handleKeydown);
      }

      function toggleMenu() {
        isOpen ? closeMenu() : openMenu();
      }

      function handleKeydown(e) {
        if (e.key === "Escape") closeMenu();
      }

      // Make the burger div act like a button.
      siteMenuBurger.setAttribute("role", "button");
      siteMenuBurger.setAttribute("tabindex", "0");
      siteMenuBurger.setAttribute("aria-expanded", "false");
      siteMenuBurger.setAttribute("aria-label", "Open menu");

      siteMenuBurger.addEventListener("click", toggleMenu);
      siteMenuBurger.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleMenu();
        }
      });

      // Close overlay when a menu link is clicked
      siteMenuOverlay.querySelectorAll("a").forEach((a) => {
        a.addEventListener("click", closeMenu);
      });
    }

    // GSAP Scrolling Effects
    // 1) Logo fade-in: start halfway through FIRST hero, finish at the end of it.
    if (siteMenuLogo && blockFirstHero) {
      gsap.set(siteMenuLogo, { opacity: 0 });

      gsap.to(siteMenuLogo, {
        opacity: 1,
        ease: "none",
        scrollTrigger: {
          trigger: blockFirstHero,
          // Start at 40% of the hero's height scrolled past.
          start: () => `top+=${blockFirstHero.offsetHeight * 0.4} top`,
          // End when the hero is fully out of view (its bottom crosses the top).
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true, // Recalc on resize/content changes
        },
      });
    }

    // 2) Site Menu Background Fill: driven by the LAST hero.
    if (blockLastHero) {
      gsap.to(siteMenu, {
        backgroundColor: "#032426",
        ease: "power2.inOut",
        scrollTrigger: {
          trigger: blockLastHero,
          start: "bottom-=100 top",
          end: "bottom top",
          scrub: true,
        },
      });
    }
  }

  // Sidebar menu submenu toggle functionality
  const initSidebarMenu = () => {
    const menuItemsWithChildren = document.querySelectorAll(
      ".sidebar-nav .has-submenu"
    );

    // Helper function to close a submenu and all its nested submenus
    const closeSubmenuRecursive = (menuItem) => {
      const submenu = menuItem.querySelector(":scope > .submenu");
      const link = menuItem.querySelector(":scope > .menu-item-link");
      const chevron = menuItem.querySelector(
        ":scope > .menu-item-link > .menu-chevron"
      );

      if (submenu)
        (submenu.classList.add("hidden"), submenu.classList.remove("block"));
      if (link) link.classList.remove("is-expanded");
      if (chevron) chevron.classList.remove("rotate-180");

      // Close all nested submenus
      menuItem.querySelectorAll(".submenu").forEach((nested) => {
        nested.classList.add("hidden");
        nested.classList.remove("block");
      });
      menuItem
        .querySelectorAll(".menu-item-link.is-expanded")
        .forEach((nestedLink) => {
          nestedLink.classList.remove("is-expanded");
        });
      menuItem
        .querySelectorAll(".menu-chevron.rotate-180")
        .forEach((nestedChevron) => {
          nestedChevron.classList.remove("rotate-180");
        });
    };

    menuItemsWithChildren.forEach((menuItem) => {
      const submenu = menuItem.querySelector(":scope > .submenu");
      const link = menuItem.querySelector(":scope > .menu-item-link");
      const chevron = menuItem.querySelector(":scope > .menu-item-link > .menu-chevron");

      if (chevron && submenu) {
        chevron.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          const isOpen = submenu.classList.contains("block");

          if (isOpen) {
            closeSubmenuRecursive(menuItem);
          } else {
            // Close siblings
            menuItem.parentElement.querySelectorAll(":scope > .has-submenu").forEach((sibling) => {
              if (sibling !== menuItem) closeSubmenuRecursive(sibling);
            });

            submenu.classList.remove("hidden");
            submenu.classList.add("block");
            if (link) link.classList.add("is-expanded");
            chevron.classList.add("rotate-180");
          }
        });
      }
    });
  };

  const autoExpandCurrentMenu = () => {
    const sidebar = document.querySelector(".sidebar-nav");
    if (!sidebar) return;

    const currentPath = window.location.pathname;
    const currentHash = window.location.hash;
    const normalizedCurrentPath = currentPath.replace(/\/$/, "") || "/";

    // Find the current active link
    const allLinks = sidebar.querySelectorAll(".menu-item-link");
    let activeLink = null;

    allLinks.forEach((link) => {
      const href = link.getAttribute("href");
      if (!href) return;

      let linkPath = "";
      if (href.startsWith("#")) {
        if (currentHash === href) activeLink = link;
        return;
      }

      try {
        linkPath = new URL(href, window.location.origin).pathname;
      } catch (e) {
        linkPath = href.split("#")[0];
      }

      const normalizedLinkPath = linkPath.replace(/\/$/, "") || "/";
      if (normalizedCurrentPath === normalizedLinkPath || normalizedCurrentPath.endsWith(normalizedLinkPath)) {
        activeLink = link;
      }
    });

    // Expand all parent submenus of the active link
    if (activeLink) {
      let parent = activeLink.closest(".has-submenu");
      while (parent) {
        const submenu = parent.querySelector(":scope > .submenu");
        const link = parent.querySelector(":scope > .menu-item-link");
        const chevron = parent.querySelector(":scope > .menu-item-link > .menu-chevron");

        if (submenu) {
          submenu.classList.remove("hidden");
          submenu.classList.add("block");
        }
        if (link) link.classList.add("is-expanded");
        if (chevron) chevron.classList.add("rotate-180");

        parent = parent.parentElement?.closest(".has-submenu");
      }
    }
  };

  const sidebar = document.querySelector(".sidebar-nav");
  if (sidebar) {
    initSidebarMenu();
    autoExpandCurrentMenu();

    // Mobile sidebar open/close toggle for the custom header burger in menu.twig.
    const sidebarBurger = document.querySelector(".sidebar-nav__burger");
    const openIcon = sidebarBurger?.querySelector(".sidebar-nav__icon--open");
    const closeIcon = sidebarBurger?.querySelector(".sidebar-nav__icon--close");
    let sidebarIsOpen = sidebar.classList.contains("is-open");

    const setSidebarOpenState = (isOpen) => {
      sidebarIsOpen = isOpen;
      sidebar.classList.toggle("is-open", isOpen);
      sidebarBurger?.setAttribute("aria-expanded", isOpen ? "true" : "false");
      sidebarBurger?.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
      if (openIcon) openIcon.classList.toggle("hidden", isOpen);
      if (closeIcon) closeIcon.classList.toggle("hidden", !isOpen);
      document.documentElement.style.overflow = isOpen ? "hidden" : "";
    };

    // Keep icon state in sync if CSS/media-query state changes.
    setSidebarOpenState(sidebarIsOpen);

    sidebarBurger?.addEventListener("click", () => {
      setSidebarOpenState(!sidebarIsOpen);
    });

    sidebarBurger?.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        setSidebarOpenState(!sidebarIsOpen);
      }
    });

    // Close sidebar when a link is clicked on mobile.
    sidebar.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        if (window.innerWidth <= 1024) {
          setSidebarOpenState(false);
        }
      });
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && sidebarIsOpen) {
        setSidebarOpenState(false);
      }
    });
  }
});
